document.addEventListener('DOMContentLoaded', () => {
    const RECAPTCHA_ERROR_CLASS = 'g-recaptcha-error';
    const RECAPTCHA_ERROR_MESSAGE = "Please confirm you're not a robot";
    const SUBMISSION_URL = `${window.location.origin}/wp-content/themes/asbestos/ajax/signup.php`;

    const clearRecaptchaErrors = () => {
        document.querySelectorAll(`.${RECAPTCHA_ERROR_CLASS}`).forEach(item => item.remove());
    };

    const displayRecaptchaError = () => {
        const label = document.createElement('label');
        label.innerHTML = RECAPTCHA_ERROR_MESSAGE;
        label.classList.add(RECAPTCHA_ERROR_CLASS, 'error');
        document.querySelectorAll('.g-recaptcha').forEach(item => item.appendChild(label));
    };

    const hideFormAndShowMessage = () => {
        const modal = document.querySelector('.c-webinar__modal');
        modal.querySelector('.c-modal__header').textContent = 'Thank You!';
        modal.insertAdjacentHTML('afterend', '<p>You will now receive webinar updates from Asbestos.com.</p>');
        document.querySelector('.js-webinarNewsletterForm').style.display = 'none';
    };

    const submitForm = (newsletter) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', SUBMISSION_URL);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = () => {
            if (xhr.status === 200) {
                hideFormAndShowMessage();
            } else {
                console.error('Form submission failed with status:', xhr.status);
            }
        };
        const fullName = encodeURIComponent(newsletter.querySelector('input[name=full_name]').value);
        const email = encodeURIComponent(newsletter.querySelector('input[name=email]').value);
        const data = `https://api.createsend.com/api/v3.2/subscribers/5f940bb10520a2eb9e73cee4e1a1a050.json&name=${fullName}&email=${email}`;
        xhr.send(data);
    };

    window.imNotARobot = clearRecaptchaErrors;

    window.formWebinarNewsletterSubmit = () => {
        const newsletter = document.querySelector('.js-webinarNewsletterForm');
        const response = grecaptcha.getResponse();

        if (response.length === 0) {
            displayRecaptchaError();
            return false;
        }

        submitForm(newsletter);
        return false;
    };
});
